import { Box, Grid2 } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import zipcodes from "zipcodes";
import Dropdown from "../../../../GlobalComponents/Dropdown/Dropdown";
//styles
import styles from "./HandoverStyle.module.scss";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import { useMakeApiCalls } from "../../../../Hooks/useMakeApiCalls";
import { useSelector } from "react-redux";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { countryStateData } from "../../../../Utils/countryStateData";
import PlanDetailsCard from "../../PlanDetailsCard/PlanDetailsCard";
//icons
import { ReactComponent as Usa } from "../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../GlobalAssets/svg/IndianSvg.svg";
import { useEmailId } from "../../../../Utils/utils";

function Handover(props) {
  const {
    selectedOrg,
    value,
    setValue,
    sendOtp,
    isSendOtp,
    selectedPlan,
    setSelectedPlan,
    activeStep,
    otp,
    setOtp,
    errorMsg,
    setErrorMsg,
    selectedCountry,
    setSelectedCountry,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
    address,
    setAddress,
    zipCode,
    setZipCode,
    zipCodeError,
    setZipCodeError,
    setPriceId,
  } = props;

  const steps = [
    {
      title: "Select an Owner or Super Admin to send OTP",
      subtext:
        "The current owner or super admin initiates the process by receiving a One-Time Password (OTP) for secure verification.",
    },
    {
      title: "OTP Verification for Requester",
      subtext:
        "The OTP is sent to notifications and registered email requesting ownership for verification, ensuring a safe and seamless transfer.",
    },
    {
      title: "Update Billing Address",
      subtext:
        "Add or update your billing details to ensure everything is accurate before transferring ownership.",
    },
    {
      title: "Create Your Own Organization",
      subtext:
        "Ready to start fresh? Select a plan, complete the payment, and set up your own organization with ease.",
    },
  ];

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_FETCH_CHILD_ORG_DETAILS,
      data: {
        orgName: selectedOrg?.name,
      },
    });
  });

  let childPlanDetails = useSelector(
    (state) => state?.organizationsInfo?.childPlanDetails
  );

  const emailId = useEmailId();

  const inputRefs = useRef([]);
  const childOrgDetails = useSelector(
    (state) => state.organizationsInfo?.childOrgDetails?.data
  );
  const [planType, setPlanType] = useState("multi");
  const [toggleType, setToggleType] = useState("monthly");
  const [stripePriceId, setStripePriceId] = useState(null);

  useEffect(() => {
    setPriceId(stripePriceId);
  }, [stripePriceId]);

  const countryOptions = [
    { label: "India", value: "India", img: <Indian /> },
    { label: "USA", value: "USA", img: <Usa /> },
  ];

  const parentMembers = selectedOrg?.members;

  const memberOptions = childOrgDetails
    ?.filter((member) => {
      const ownerMember = childOrgDetails.find(
        (child) =>
          child.emailId === member.emailId && child.userRole === "ORG_OWNER"
      );

      const parentOwner = parentMembers.find(
        (parent) => parent.roleDesc === "OWNER"
      );
      return (ownerMember && parentOwner) || member.emailId !== emailId;
    })
    .map((member) => ({
      label: member.userName,
      value: member.userId,
    }));

  // enter otp value only if current number is entered
  const handleOtpChange = (index, value) => {
    setErrorMsg("");
    const numericValue = value.replace(/\D/g, "");
    const updatedOtp = [...otp];
    updatedOtp[index] = numericValue;
    setOtp(updatedOtp);

    // Automatically focus on the next input if the current one is filled
    if (numericValue && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const validateZipCode = (zipCode, country) => {
    if (!zipCode) return;

    let isValid = false;

    // Check validity based on country
    if (country === "USA") {
      const zipData = zipcodes.lookup(zipCode);
      isValid = !!zipData;
    } else if (country === "India") {
      const indiaZipCodeRegex = /^[1-9]{1}[0-9]{5,7}$/;
      isValid = indiaZipCodeRegex.test(zipCode);
    }
    return isValid;
  };

  return (
    <Grid2>
      <Grid2 className={styles.stepper}>
        {/* <CustomizedSteppers steps={steps} activeStep={activeStep} /> */}
        <Grid2 className={styles.label}>Get Handover</Grid2>
        {steps.map((step, index) => (
          <span className={styles.margin}>
            <Grid2 key={index} className={styles.stepperText}>
              <Grid2 className={styles.radioBtn}>
                {index === activeStep ? (
                  <RadioButtonUncheckedIcon
                    className={styles.iconChecked}
                    sx={{ fontSize: "18px" }}
                  />
                ) : index <= activeStep ? (
                  <CheckCircleOutlineIcon
                    className={styles.iconChecked}
                    sx={{ fontSize: "18px" }}
                  />
                ) : (
                  <RadioButtonUncheckedIcon
                    className={styles.iconUnchecked}
                    sx={{ fontSize: "18px" }}
                  />
                )}
              </Grid2>
              <Grid2 className={styles.stepText}>{step.title}</Grid2>
            </Grid2>
            <Grid2 className={styles.subTextContainer}>
              {index === activeStep && (
                <Grid2 className={styles.subText}>{step.subtext}</Grid2>
              )}
            </Grid2>
          </span>
        ))}
      </Grid2>
      {activeStep === 0 && (
        <Grid2 className={styles.marginTop}>
          <Dropdown
            title={"Select Your Request Owner"}
            placeholder={"Select an Owner / Super Admin"}
            options={memberOptions}
            value={value}
            onSelect={setValue}
          />
          {memberOptions?.length === 0 ? (
            <span className={styles.errorMsg}>
              There are no eligible members who are part of both the Managing
              and Your Organization.
            </span>
          ) : null}
        </Grid2>
      )}
      {activeStep === 1 && isSendOtp && (
        <Grid2
          container
          direction="column"
          alignItems="left"
          spacing={2}
          className={styles.marginTop}
        >
          <span className={styles.otpLabel}>Enter OTP</span>
          <Grid2 className={styles.otpContainer}>
            <Box
              display="flex"
              sx={{
                gap: "10px",
              }}
            >
              {Array.from({ length: 4 }).map((_, index) => (
                <input
                  className={styles.otpInput}
                  key={index}
                  type="text"
                  maxLength={1}
                  value={otp[index]}
                  onChange={(e) => handleOtpChange(index, e?.target?.value)}
                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onInput={(e) => {
                    // Only allow numeric values
                    if (!/^\d*$/.test(e.target.value)) {
                      e.target.value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                    }
                  }}
                  onPaste={(e) => {
                    const pasteData = e.clipboardData.getData("text").trim();
                    if (/^\d+$/.test(pasteData)) {
                      const pastedValues = pasteData.split("");
                      const newOtp = [...otp];
                      pastedValues.forEach((value, i) => {
                        if (index + i < otp.length) {
                          newOtp[index + i] = value;
                        }
                      });
                      setOtp(newOtp);
                    }
                  }}
                />
              ))}
            </Box>
            <div className={styles.resendOtp} onClick={sendOtp}>
              Resend OTP
            </div>
          </Grid2>
          {errorMsg && (
            <div className={styles.errorMsg}>
              The OTP you entered is incorrect
            </div>
          )}
          <div
            className={styles.subText}
            style={{
              marginBottom: errorMsg && "-5px",
            }}
          >
            OTP sent to owner notifications & Email
          </div>
        </Grid2>
      )}
      {activeStep === 2 && (
        <>
          <Grid2 className={styles.step3Style}>
            <Dropdown
              title={"Country"}
              options={countryOptions}
              value={selectedCountry}
              onSelect={setSelectedCountry}
            />
            <Dropdown
              title={"State"}
              key={selectedCountry}
              options={countryStateData[selectedCountry]}
              placeholder="Select State"
              value={selectedState}
              onSelect={(value) => {
                setSelectedState(value);
              }}
              optlabel={"label"}
              optvalue={"value"}
            />
          </Grid2>
          <Grid2 className={styles.step3Style}>
            <CustomInput
              title={"City"}
              placeholder={"Enter City Name"}
              value={selectedCity}
              setValue={(e) => {
                if (/^[a-zA-Z\s]*$/.test(e)) {
                  setSelectedCity(e);
                }
              }}
            />
            <CustomInput
              title={"Zip Code"}
              placeholder={"Enter Zip code"}
              value={zipCode}
              setValue={(e) => {
                if (!isNaN(e) && e.length <= 10) {
                  const isValid = validateZipCode(e, selectedCountry);

                  setZipCode(e);
                  setZipCodeError(!isValid || e?.length === 0);
                }
              }}
              error={zipCodeError}
            />
          </Grid2>
          <Grid2 className={styles.step3Style}>
            <CustomInput
              title={"Address"}
              placeholder={"Enter Address"}
              value={address}
              setValue={setAddress}
            />
          </Grid2>
        </>
      )}
      {activeStep === 3 && (
        <>
          <PlanDetailsCard
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            recommendedPlanId={childPlanDetails?.recommendedPlanId}
            numOfSites={childPlanDetails?.numOfSites}
            selectedOrg={selectedOrg}
            planType={planType}
            setPlanType={setPlanType}
            toggleType={toggleType}
            setToggleType={setToggleType}
            priceId={stripePriceId}
            setPriceId={setStripePriceId}
          />
        </>
      )}
    </Grid2>
  );
}

export default Handover;
